export default [
	{
		path: '/sale',
		name: 'sale',
		meta: {
			title: '销售管理',
			isLink: '',
			isHide: false,
			isKeepAlive: false,
			isAffix: false,
			isIframe: false,
			roles: ['admin'],
			icon: 'iconfont icon-xitongshezhi',
		},
		children:[
			{
				path: '/sale/saleManagement',
				name: 'saleManagement',
				component: () => import('/@/views/saleManagement/index.vue'),
				meta: {
					title: '销售管理',
					isLink: '',
					isHide: false,
					isKeepAlive: false,
					isAffix: false,
					isIframe: false,
					roles: ['admin']
				}
			},
		]
	},
	{
		path: '/custom',
		name: 'custom',
		meta: {
			title: '客户管理',
			isLink: '',
			isHide: false,
			isKeepAlive: false,
			isAffix: false,
			isIframe: false,
			roles: ['admin'],
			icon: 'iconfont icon-xitongshezhi',
		},
		children:[
			{
				path: '/custom/clinicInfo',
				name: 'clinicInfo',
				component: () => import('/@/views/clinicInfo/index.vue'),
				meta: {
					title: '诊所信息',
					isLink: '',
					isHide: false,
					isKeepAlive: false,
					isAffix: false,
					isIframe: false,
					roles: ['admin']
				}
			},
			{
				path: '/custom/doctorInfo',
				name: 'doctorInfo',
				component: () => import('/@/views/doctorInfo/index.vue'),
				meta: {
					title: '医生信息',
					isLink: '',
					isHide: false,
					isKeepAlive: false,
					isAffix: false,
					isIframe: false,
					roles: ['admin']
				}
			},
      {
        path: '/custom/accountInfo',
        name: 'accountInfo',
        component: () => import('/@/views/accountInfo/index.vue'),
        meta: {
          title: '账户管理',
          isLink: '',
          isHide: false,
          isKeepAlive: false
        }
      }
		]
	},
  {
    path: '/product',
    name: 'product',
    meta: {
      title: '产品管理',
      isLink: '',
      isHide: false,
      isKeepAlive: false,
      isAffix: false,
      isIframe: false,
      roles: ['admin'],
      icon: 'iconfont icon-xitongshezhi',
    },
    children: [
      {
        path: '/product/purifyList',
        name: 'purifyList',
        component: () => import('/@/views/purify/index.vue'),
        meta: {
          title: '美白产品',
          isLink: '',
          isHide: false,
          isKeepAlive: false,
          isAffix: false,
          isIframe: false,
          roles: ['admin']
        }
      },
      {
        path: '/product/inventory',
        name: 'inventory',
        component: () => import('/@/views/merchantInventory/index.vue'),
        meta: {
          title: '门诊库存情况',
          isLink: '',
          isHide: false,
          isKeepAlive: false,
          isAffix: false,
          isIframe: false,
          roles: ['admin']
        }
      }
    ]
  },
  {
    path: '/agent',
    name: 'agent',
    meta: {
      title: '经销商库存',
      isLink: '',
      isHide: false,
      isKeepAlive: false,
      isAffix: false,
      isIframe: false,
      roles: ['admin'],
      icon: 'iconfont icon-xitongshezhi',
    },
    children: [
      {
        path: '/agent/agentInventory',
        name: 'agentInventory',
        component: () => import('/@/views/agentInventory/index.vue'),
        meta: {
          title: '经销商库存',
          isLink: '',
          isHide: false,
          isKeepAlive: false,
          isAffix: false,
          isIframe: false,
          roles: ['admin']
        }
      }
    ]
  }
]
